import SerialNumber from './SerialNumber.connect'

export default SerialNumber
